import ModelEntity from "../model-entity"
import {EntityType} from "../../gd/const/item"
import ModelProxy from "../model-proxy"
import {PinDocument, PinLocation, PinProject, PinTask, PinType, PinUser} from "./@types"

export default class Pin extends ModelEntity {

    public companyId        : ID
    public customViewId?    : ID
    public project?         : PinProject
    public task?            : PinTask
    public user?            : PinUser
    public document?        : PinDocument

    public location         : PinLocation

    constructor(data: any, useProxy = true) {
        super(data['id'], EntityType.PIN)

        this.companyId      = data.companyId
        this.customViewId   = data.customViewId
        this.project        = data.project
        this.task           = data.task
        this.user           = data.user
        this.document       = data.document

        this.location       = data.location || {type: 'home'}

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    get isProject():boolean {
        return !!this.project
    }

    get type():EntityType {

        if (this.task)                  return EntityType.TASK_TYPE
        else if (this.project)          return EntityType.PROJECT
        else if (this.user)             return EntityType.USER
        else if (this.customViewId)     return EntityType.CUSTOM_VIEW
        else if (this.document)         return EntityType.DOCUMENT

        console.log("badPin id=", this.id)

        throw Error("#09d83kkk Unknown pin type")

    }

    getType() {
        let result

        if (this.task)                  result = PinType.TASK
        else if (this.project)          result = PinType.PROJECT
        else if (this.user)             result = PinType.USER
        else if (this.customViewId)     result = PinType.CUSTOM_VIEW
        else if (this.document)         result = PinType.DOCUMENT

        return result
    }

    goTo() {
        if (this.task)          gd.taskView.open(this.task.id)
        else if (this.project)  gd.goTo('p/'+this.project.id)
        else if (this.user)     gd.goTo('u/'+this.user.companyId+'-'+this.user.userId+'/dashboard')
        else if (this.customViewId) {
            const customView = gd.session.customViews.get(this.customViewId)
            if (customView) return customView.url
        }
        else if (this.document) gd.goTo('n/'+this.document.id)

        return null
    }

    get isValid():boolean {

        // some pins are empty ... for example deleted documents
        // so we need validate them before adding to the collection
        if (this.customViewId || this.task || this.user || this.document) {
            return true
        }

        // Check if this pin is a project pin
        if (this.project) {
            // Only valid if the project is not a workspace project
            return !gd.session.projects.get(this.project.id)?.isWorkspace
        }

        return false
    }

    toJSON() {
        return {
            id              : this.id,
            companyId       : this.companyId,
            customViewId    : this.customViewId,
            project         : this.project,
            task            : this.task,
            user            : this.user,
            document        : this.document,

            location        : this.location,
        }
    }
}
